import styled from 'styled-components';

const getVariantStyles = (variant) => {
  const styles = {
    info: {
      backgroundColor: '#f8f9fa',
      borderLeftColor: '#007bff',
      color: '#666',
    },
    warning: {
      backgroundColor: '#fff3cd',
      borderLeftColor: '#ffc107',
      color: '#856404',
    },
    error: {
      backgroundColor: '#f8d7da',
      borderLeftColor: '#dc3545',
      color: '#721c24',
    },
    success: {
      backgroundColor: '#d4edda',
      borderLeftColor: '#28a745',
      color: '#155724',
    },
  };

  return styles[variant] || styles.info;
};

export const InfoNoteStyled = styled.div`
  font-size: 0.85rem;
  font-style: italic;
  margin-top: 8px;
  margin-bottom: 8px;
  padding: 4px 8px;
  border-left: 3px solid;
  border-radius: 4px;
  line-height: 1.4;

  ${({ variant }) => {
    const styles = getVariantStyles(variant);
    return `
      background-color: ${styles.backgroundColor};
      border-left-color: ${styles.borderLeftColor};
      color: ${styles.color};
    `;
  }}
`;
